module.exports = __webpack_public_path__ + "static/RootSans-5Regular-5a02ba0ec049b383909d940be8efd857.woff";